import { render, staticRenderFns } from "./ZoneTemplate.vue?vue&type=template&id=0b00c1b0"
import script from "./ZoneTemplate.vue?vue&type=script&lang=js"
export * from "./ZoneTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports